import { EyeOffIcon } from "assets/icons";
import cn from "classnames";
import { Media } from "components";
import { memo } from "react";
import { Icon } from "ui";

import { EProductVariantVisibility } from "../../constants";
import { ProductCellProps } from "./ProductCell.types";

import styles from "./ProductCell.module.scss";

const ProductCell = ({
  name,
  subtitle,
  image,
  imageClassName,
  containerClassName,
  nameClassName,
  subtitleClassName,
  visibility = EProductVariantVisibility.Visible
}: ProductCellProps) => {
  const isHiddenInFeed = visibility !== EProductVariantVisibility.Visible;
  const iconColor =
    visibility === EProductVariantVisibility.Hidden ? "#FF0033" : "#FF754C";
  return (
    <div className={cn(styles.productCell, containerClassName)}>
      <div className={cn(styles.productCell_productImageThumb, imageClassName)}>
        <Media className={styles.productCell_productImage} mediaFile={image} />
      </div>

      <div className={styles.productCell_textContainer}>
        <div className={cn(styles.accentText, nameClassName)}>
          {name}
          {isHiddenInFeed && (
            <Icon
              as={EyeOffIcon}
              fill={iconColor}
              width={18}
              height={18}
              className={styles.hiddenForResellersIcon}
            />
          )}
        </div>
        <div
          className={cn(
            styles.productCell_textContainer_subtitle,
            subtitleClassName
          )}
        >
          {subtitle}
        </div>
      </div>
    </div>
  );
};

export default memo(ProductCell);
